import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

// Selectable card used across the wizard (industry, workload, growth, pain points)
export const OptionCard = ({
  selected,
  onClick,
  title,
  description,
  icon: Icon,
  multi = false,
  testId,
}) => (
  <motion.button
    type="button"
    onClick={onClick}
    whileTap={{ scale: 0.98 }}
    data-testid={testId}
    aria-pressed={selected}
    className={`relative text-left w-full rounded-xl p-4 sm:p-5 border transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(30,107,255,0.55)] ${
      selected
        ? "border-[#1E6BFF] ring-2 ring-[rgba(30,107,255,0.35)]"
        : "border-white/10 hover:border-white/25"
    }`}
    style={{ backgroundColor: selected ? "#101a33" : "#0F1424" }}
  >
    <div className="flex items-start gap-3">
      {Icon && (
        <span
          className={`shrink-0 rounded-lg p-2 ${
            selected ? "bg-[#1E6BFF] text-white" : "bg-white/5 text-[#66B2FF]"
          }`}
        >
          <Icon size={18} />
        </span>
      )}
      <div className="min-w-0">
        <div className="text-white font-semibold text-sm sm:text-base">{title}</div>
        {description && (
          <div className="text-white/60 text-xs sm:text-sm mt-0.5 leading-relaxed">
            {description}
          </div>
        )}
      </div>
    </div>
    <span
      className={`absolute top-3 right-3 h-5 w-5 rounded-full flex items-center justify-center border transition-colors ${
        selected ? "bg-[#1E6BFF] border-[#1E6BFF]" : "border-white/20"
      }`}
    >
      {selected && <Check size={13} className="text-white" />}
    </span>
  </motion.button>
);

export default OptionCard;
